import type { ModuleManifest } from "@dd/module-api";
import type { CaseV1Data } from "@dd/schema";
import type { AppDef } from "../apps/registry";
import { BANCO_MANIFEST } from "./banco/manifest";
import { REGISTRO_MANIFEST } from "./registro/manifest";

/**
 * Registro de módulos instalables (F1-T07, os §3). El core no conoce módulos
 * por nombre: este archivo es el único punto de registro, y el caso decide
 * cuáles se instalan (`requiredModules`). Un caso sin módulos monta el OS
 * exactamente como en F0.
 */

export const MODULE_REGISTRY: readonly ModuleManifest[] = [BANCO_MANIFEST, REGISTRO_MANIFEST];

export function modulesFor(kase: CaseV1Data): readonly ModuleManifest[] {
  return MODULE_REGISTRY.filter((m) => kase.requiredModules.includes(m.id));
}

/** Los módulos activos como AppDefs — el shell los trata igual que a las apps core */
export function moduleAppDefs(kase: CaseV1Data): AppDef[] {
  return modulesFor(kase).map((m) => ({
    id: m.id,
    title: m.title,
    glyph: m.glyph,
    component: m.component,
    defaultSize: m.defaultSize,
  }));
}
